<template>
  <el-container>
    <el-header class="header">
      <div class="header_box">
        <div class="head_info">
          <img class="user_img" :src="baseUrl + userInfo.avatar" alt="" />
          <div class="user_name">{{ userInfo.nickname }}</div>
        </div>
        <div class="right_box">
          <div class="message_box">
            <i class="el-icon-bell" @click="goNoctice"></i>
            <div class="message" v-show="is_read == 0 ? true : false"></div>
          </div>

          <div class="quite_box" @click="loginOut">
            <div class="quite_txt">退出</div>
            <img src="../assets/icon/quite.png" alt="" />
          </div>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside
        class="aside"
        :width="isShowMenu ? '250px' : '20px'"
        v-show="equipmentType == 0 ? true : false"
      >
        <!-- 金主 type==1-->
        <owner v-if="userInfo.type == 1" v-show="isShowMenu" />
        <!-- 写手 type==2-->
        <writer v-else v-show="isShowMenu" />
        <!-- 侧边菜单栏展开和收起 -->
        <div class="close_menu" @click="showMenu()">
          <i class="el-icon-caret-left"></i>
        </div>
      </el-aside>
      <!-- 主体内容 -->
      <el-main :class="equipmentType == 1 ? 'mobile_main' : ''">
        <router-view></router-view>
      </el-main>
      <div
        class="foot_box"
        id="foot_nav"
        v-show="equipmentType == 1 ? true : false"
      >
        <MobileOwner v-show="userInfo.type == 1"></MobileOwner>
        <MobileWriter v-show="userInfo.type == 2"></MobileWriter>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import Owner from "@/components/Owner";
import Writer from "@/components/Writer";
import MobileOwner from "@/components/MobileOwner";
import MobileOwnerData from "@/components/MobileOwnerData";
import MobileWriter from "@/components/MobileWriter";
import MobileWriterData from "@/components/MobileWriterData";
import { logout } from "@/utils/api";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl,
      isShowMenu: true, //侧边菜单栏的收缩按钮
      userInfo: null, //用户信息
      noticeList: [], //消息通知
      is_read: null, //消息提醒红点
      equipmentType: 0, //设备 0-pc端 1移动端
      showOwner: false, //金主、写手菜单
      showOwnerData: false, //数据中心
      isActive: 0 //选项卡
    };
  },
  created() {
    //用户信息
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    console.log("userInfo", this.userInfo);
    this.is_read = JSON.parse(sessionStorage.getItem("is_read"));
  },
  mounted() {
    var that = this;
    // 根据不同路由跳转不同页面
    if (this.$isMobile.isDeviceType()) {
      //  手机端
      // console.log("手机端", that.equipmentType);
      that.equipmentType = 1;
    } else {
      //  pc端
      that.equipmentType = 0;
      // console.log("pc端", that.equipmentType);
    }
  },
  components: {
    Owner, //金主组件
    Writer, //写手组件
    MobileOwner, //移动端金主组件
    MobileOwnerData, //移动端金主数据中心组件
    MobileWriter, //移动端写手组件
    MobileWriterData //移动端写手数据中心组件
  },

  methods: {
    handleOwner(val) {
      this.isActive = val;
      this.showOwner = !this.showOwner;
      this.showOwnerData = false;
    },
    handleOwnerData(val) {
      this.isActive = val;
      this.showOwnerData = !this.showOwnerData;
      this.showOwner = false;
    },
    // 去消息通知
    goNoctice() {
      var that = this;
      that.$router.push("/home");
    },
    // pc端的收起
    showMenu() {
      var that = this;
      that.isShowMenu = !that.isShowMenu;
    },
    // 用户退出
    loginOut() {
      var that = this;
      if (this.$isMobile.isDeviceType()) {
        // 手机端
        that
          .$confirm("确定要退出吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "message-logout",

            type: "warning"
          })
          .then(() => {
            logout().then(res => {
              if (res.data.code == 1) {
                that.$message.success(res.data.msg);
                localStorage.clear(); // 点击确定后  清除session用户信息
                that.$router.push(`/login`); // 跳转到登录页面
              } else {
                that.$message.error(res.data.msg);
              }
            });
          });
      } else {
        that
          .$confirm("确定要退出吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            logout().then(res => {
              if (res.data.code == 1) {
                that.$message.success(res.data.msg);
                localStorage.clear(); // 点击确定后  清除session用户信息
                that.$router.push(`/login`); // 跳转到登录页面
              } else {
                that.$message.error(res.data.msg);
              }
            });
          });
      }
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

/* 头部 */
.header {
  background: #f5f7fa;
  border: 1px solid #e4e9f1;
}
.header_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.head_info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.user_img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.user_name {
  margin-left: 5px;
}
.quite_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.quite_box img {
  width: 15px;
  height: 15px;
  margin-left: 5px;
}
.right_box {
  width: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.right_box i {
  font-size: 20px;
}
/* 头部 */

/* 侧边栏 */
.aside {
  height: 93vh;
  /* background: #F5F7FA; */
  background: #fff;
  position: relative;
  border: 1px solid #e4e9f1;
  border-bottom: none;
}
.close_menu {
  width: 15px;
  height: 50px;
  line-height: 50px;
  background-color: #e0e3e9;
  position: absolute;
  top: 50%;
  right: 0%;
}
.close_menu i {
  font-size: 12px;
}
/* 侧边栏 */
.el-tag {
  height: 25px;
  line-height: 25px;
  border-radius: 15px;
}

.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.mobile_main {
  margin-bottom: 300px;
}
.message_box {
  display: flex;
  flex-direction: row;
}
.message {
  background: red;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

/* 移动端 */

.foot_box {
  width: 100%;
  position: fixed;
  bottom: 0px;
  background: #fff;
  border: 1px solid #e4e9f1;
  z-index: 99999;
}
/* 
.foot_item {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
}
.foot_item_active {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
  background: #94c4fc;
  color: #fff;
}
.moblie_menu_list {
  position: absolute;
  bottom: 100%;
  left: 0%;
  width: 99%;
  background: #fff;
  border: 1px solid #e4e9f1;
  z-index: 99999;
} */
.moblie_content {
  margin-bottom: 150px;
}
</style>
<style>
@media screen and (max-width: 750px) and (min-width: 375px) {
  .message-logout {
    width: 320px !important;
  }
}
</style>
<style>
.el-scrollbar__thumb {
  background-color: rgba(142, 147, 153, 0.9) !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Index.vue